import { FC, useEffect, useState } from "react"
import './auth.css'
import api from "../../services/api"
import { usePluginspace } from "../../hooks/usePluginspace"
import { ConfigType } from "../../contexts/AppConfigContext"
import { useOutletContext } from "react-router-dom"
import { useAppConfig } from "../../hooks/useAppConfig"
import { Loading } from "../../components/Loading"
import { Outlet, Route, Routes } from 'react-router-dom'

import { Login } from "./login/login"
import { ForgotPassword } from "./resetPassword/reset"
import { Footer } from "../../components/Footer/footer"


type ContextType = { config: ConfigType | null };

const AuthLayout = () => {
    const [categoryId, setCategoryId] = useState('');
    const { getAppConfig } = useAppConfig();
    const [config, setConfig] = useState<ConfigType | void>();

    const [loading, setLoading] = useState(true);

    const { getToken } = usePluginspace()

    async function getCategory() {

        await api.post('/api/classification/filter',
            {
                code: '1',
            },
            {
                headers: {
                    'Authorization': `Bearer ${await getToken()}`
                }
            }).then(async (response) => {
                if (response.data.data[0]) {
                    setCategoryId(response.data.data[0].id);
                }
            })
            .catch((err) => {
                setLoading(false);
            })
    }


    async function getConfig() {
        setLoading(true)
        const _config = await getAppConfig();
        // if (_config && (_config.template === "food" || _config.template === "retail") && _config.content.pdv.showLayout === 'l2') {
        //     await getCategory()
        // }
        setConfig(_config);
        setLoading(false)
    }

    useEffect(() => {
        getConfig()
    }, [])


    return (
        <div className="homeAuth">
            {loading ?
                <div style={{ width: '100%', height: 'calc(100vh)' }}>
                    <Loading
                        type="spinningBubbles"
                        color="#FFF"
                        width={64}
                        height={64}
                    />
                </div>
                :
                <div className="homeAuthContent">
                    <div className="homeAuthContent2">
                        <div className="homeLogo">
                            {(config?.img && !config.img.includes('null')) &&
                                <img src={config.img} alt="Logo" />
                            }
                        </div>

                        <Outlet context={{ config }} />
                    </div>
                    <Footer />
                </div>
            }
        </div>
    )
}


const AuthPage = () => {

    const { getThisPluginspace } = usePluginspace()

    async function aye(){
        const x = await getThisPluginspace()

        console.log(x)
    }

    useEffect(()=>{
        aye()
    },[])


    return (



        <Routes >
            <Route element={<AuthLayout />}>
                <Route path='login' element={<Login />} />
                {/*<Route path='esqueci-senha' element={<ForgotPassword />} /> */}
                <Route index element={<Login />} />
            </Route>
        </Routes >
    )

}
export { AuthPage }

export function useConfig() {
    return useOutletContext<ContextType>();
}